import React, { useEffect } from "react";
import "./css/index.css";

import { BrowserRouter } from "react-router-dom";
import { Routes } from "./routes";
import { ToastAnimated } from "./components/global/toast";
import { LoadingProvider } from "./components/global/loading";
import { AuthProvider } from "./shared/contexts/auth.context";

const App: React.FC = () => {
    useEffect(() => {
        const isMagno = window.location.href.includes("magnovieira");

        if (isMagno) {
            const link = (document.querySelector("link[rel='icon']") ||
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                document.createElement("link")) as any;
            link.rel = "icon";
            link.href = `${window.location.origin}/magno-favicon.ico`;
            document.head.appendChild(link);

            let metaDescription = document.querySelector(
                "meta[name='description']"
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ) as any;
            if (!metaDescription) {
                metaDescription = document.createElement("meta");
                metaDescription.name = "description";
                document.head.appendChild(metaDescription);
            }

            metaDescription.content =
                "Ferramenta de georreferenciamento desenvolvida pela Magno Vieira.";
        }
    }, []);

    return (
        <>
            <AuthProvider>
                <LoadingProvider>
                    <BrowserRouter>
                        <Routes />
                    </BrowserRouter>
                </LoadingProvider>
            </AuthProvider>
            <ToastAnimated />
        </>
    );
};

export default App;
